const onGetDetailPageNameSrp = (showNoResults, experience = '') => {
    if (experience?.includes('hyundai-buy-online')) {
        return 'srp_buy-online_oem';
    }

    if (experience?.includes('buy-online')) {
        return 'srp_buy-online';
    }

    if (experience?.includes('car-bravo')) {
        return 'srp-carbravo';
    }

    if (showNoResults) {
        return 'srp_no_results';
    }

    return 'srp';
};

const onGetCdlDetailPageNameVdp = (experience = '') => {
    if (experience?.includes('hyundai-buy-online')) {
        return 'vdp_buy-online_oem';
    }

    if (experience?.includes('buy-online')) {
        return 'vdp_buy-online';
    }

    return '';
};

export default function dataLayerTransform({ pageName, showNoResults, expiredVdp, experience }) {
    let siteSection = '';
    let pageType = '';
    let detailPageName = '';
    let cdlDetailPageName = '';
    switch (pageName) {
        case 'srp': {
            siteSection = 'find-your-car';
            pageType = showNoResults ? 'srp_no_results' : 'srp';
            detailPageName = onGetDetailPageNameSrp(showNoResults, experience);
            break;
        }

        case 'vdp': {
            siteSection = 'find-your-car';
            pageType = expiredVdp ? 'vdp_exp' : 'vdp';
            detailPageName = expiredVdp ? 'vdp_exp' : 'vdp';
            cdlDetailPageName = onGetCdlDetailPageNameVdp(experience);
            break;
        }

        case 'sfp': {
            siteSection = 'find-your-car';
            pageType = 'asf';
            detailPageName = 'asf';
            break;
        }

        case 'fordlanding': {
            siteSection = 'find-your-car';
            pageType = 'slp_fba';
            detailPageName = 'slp_fba';
            break;
        }

        case 'bap': {
            siteSection = 'find-your-car';
            pageType = 'build-and-price';
            detailPageName = 'build-and-price';
            break;
        }

        case 'inv': {
            siteSection = 'find-your-car';
            pageType = 'vdp';
            detailPageName = 'hybrid_vdp';
            break;
        }

        default:
    }

    return {
        siteSection,
        pageType,
        detailPageName,
        cdlDetailPageName,
    };
}
